<template>
    <div class="notification-card" :class="{ seen: notification.seen }">
        <ActivityCard :activity="notification.activity" :show-date="false" />
        <div class="metas">
            <span class="date">{{ $moment(notification.createdAt).fromNow() }}</span>
            <div
                class="mark-read"
                :class="{ seen: notification.seen }"
                v-tippy="{
                    followCursor: false,
                    placement: 'left',
                }"
                @click="notificationSeen"
                :content="'Mark as Read'"
            ></div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import ActivityCard from "../Activity/ActivityCard.vue";
import { ACTIVITY_API } from "../../../api/activity";

export default Vue.extend({
    name: "NotificationCard",
    components: { ActivityCard },
    props: {
        notification: {},
    },
    methods: {
        ...mapActions({
            setNotificationCount: "app/setNotificationCount",
            subNotificationCount: "app/subNotificationCount",
            addNotificationCount: "app/addNotificationCount",
        }),
        notificationSeen() {
            const promiseFn = this.notification.seen
                ? ACTIVITY_API.NOTIFICATION.markAsUnSeen
                : ACTIVITY_API.NOTIFICATION.markAsSeen;
            promiseFn([this.notification._id]).then(() => {
                if (this.notification.seen) {
                    this.addNotificationCount(1);
                    this.$emit("markUnread", this.notification._id);
                } else {
                    this.subNotificationCount(1);
                    this.$emit("markRead", this.notification._id);
                }
            });
        },
    },
});
</script>

<style scoped lang="scss">
.notification-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:not(.seen) {
        background-color: white;
    }

    .metas {
        width: max-content;
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: flex-end;
        .mark-read {
            &:not(.seen) {
                width: 1rem;
                height: 1rem;
                background: #1999e3;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                &:hover {
                    box-shadow: 0 0 0 4px #d9dbe0;
                    &:after {
                        content: "✓";
                        color: white;
                        font-size: 10px;
                        font-weight: bolder;
                        line-height: 10px;
                    }
                }
            }
            &.seen {
                width: 1rem;
                height: 1rem;
                border: 1px solid #c7d0d7;
                background-color: white;
                border-radius: 50%;
                &:hover {
                    box-shadow: 0 0 0 4px #d9dbe0;
                }
            }
        }
    }

    .activity-card {
        width: calc(100% - 100px);
        padding: 0 !important;
        background: none !important;
    }
    .date {
        position: relative;
        display: inline;
        white-space: nowrap;
        &:after {
            content: "";
            display: none;
        }
    }
}
</style>
